import { useQuery } from '@tanstack/react-query'

import {
  FromCalendarType,
  getCalendarDiagnoses,
} from '@/services/get-calendar-diagnoses'

import { useCompanies } from '../use-companies'

export const GET_CALENDAR_DIAGNOSES_QUERY = ['mappings']

interface UseCalendarDiagnosesProps {
  search: string
  type: FromCalendarType
}

export function useGetCalendarDiagnoses({
  search,
  type,
}: UseCalendarDiagnosesProps) {
  const { selectedCompany } = useCompanies()

  const query = useQuery({
    queryKey: [
      ...GET_CALENDAR_DIAGNOSES_QUERY,
      selectedCompany?.id,
      { search, type },
    ],
    queryFn: ({ signal }) =>
      getCalendarDiagnoses({ from: type, search }, { signal }),
    staleTime: 1000 * 10, // 10 seconds,
  })

  return query
}
